import React from 'react'
import SparxLogo from '../SparxLogo'

function AccessRestrictedModal({ message = 'Access restricted' }) {
  return (
    <div className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center">
      <SparxLogo className="mb-[24px]" />
      <div className="text-black text-2xl font-medium">
        {message}
      </div>
    </div>
  )
}

export default AccessRestrictedModal
